const cameraList = [{
    id: 15,
    name: "厂区东北角球机",
    cameraName: "厂区东北角球机",
    classifyName: "清洁道路",
    nvrPassword: "hik12345",
    nvrUsername: "admin",
    //ipAddress: "30.100.103.5",
    noReplay: true,
    nvrIp: "172.31.64.3",
    channelId: "15",
    cameraName: "厂区东北角球机",
    cameraIp: "30.100.103.5",
    password: "hik12345",
    top: 1350,
    left: 950,
    transform: 'rotate(270deg)',
    latitude: 39.50883797,
    longitude: 118.28061884
}, {
    id: 16,
    name: "新北区大门口球机",
    cameraName: "新北区大门口球机",
    classifyName: "清洁道路",
    nvrPassword: "hik12345",
    nvrUsername: "admin",
    //ipAddress: "30.100.103.6",
    noReplay: true,
    nvrIp: "172.31.64.3",
    channelId: "16",
    cameraIp: "30.100.103.6",
    password: "hik12345",
    top: 1350,
    left: 820,
    transform: 'rotate(270deg)',
    latitude: 39.50553374,
    longitude: 118.28095183
}, {
    id: 5,
    name: "新北区制氧东门北角",
    cameraName: "新北区制氧东门北角",
    classifyName: "清洁道路",
    nvrPassword: "hik12345",
    nvrUsername: "admin",
    //ipAddress: "30.100.103.10",
    noReplay: true,
    nvrIp: "172.31.64.3",
    channelId: "5",
    cameraIp: "30.100.103.10",
    password: "hik12345",
    top: 1380,
    left: 750,
    transform: 'rotate(270deg)',
    latitude: 39.50453170,
    longitude: 118.28126944
}, {
    id: 17,
    name: "老区炼钢东门球机",
    cameraName: "老区炼钢东门球机",
    classifyName: "清洁道路",
    nvrPassword: "hik12345",
    nvrUsername: "admin",
    //ipAddress: "30.100.102.7",
    noReplay: true,
    nvrIp: "172.31.64.3",
    channelId: "17",
    cameraIp: "30.100.102.7",
    password: "hik12345",
    top: 1350,
    left: 720,
    transform: 'rotate(270deg)',
    latitude: 39.50071718,
    longitude: 118.28088450
}, {
    id: 18,
    name: "东门地泵东球机",
    cameraName: "东门地泵东球机",
    classifyName: "清洁道路",
    nvrPassword: "hik12345",
    nvrUsername: "admin",
    //ipAddress: "30.100.103.7",
    noReplay: true,
    nvrIp: "172.31.64.3",
    channelId: "18",
    cameraIp: "30.100.103.7",
    password: "hik12345",
    top: 1250,
    left: 280,
    transform: 'rotate(270deg)',
    latitude: 39.49380628,
    longitude: 118.28124802
}, {
    id: 20,
    name: "850大道南球机",
    cameraName: "850大道南球机",
    classifyName: "清洁道路",
    nvrPassword: "hik12345",
    nvrUsername: "admin",
    //ipAddress: "30.100.102.3",
    noReplay: true,
    nvrIp: "172.31.64.3",
    channelId: "20",
    cameraIp: "30.100.102.3",
    password: "hik12345",
    top: 1150,
    left: 150,
    transform: 'rotate(270deg)',
    latitude: 39.49079315,
    longitude: 118.27607555
}, {
    id: 19,
    name: "二号门门口球机",
    cameraName: "二号门门口球机",
    classifyName: "清洁道路",
    nvrPassword: "hik12345",
    nvrUsername: "admin",
    //ipAddress: "30.100.102.2",
    noReplay: true,
    nvrIp: "172.31.64.3",
    channelId: "19",
    cameraIp: "30.100.102.2",
    password: "hik12345",
    top: 1040,
    left: 150,
    transform: 'rotate(270deg)',
    latitude: 39.49079315,
    longitude: 118.27767555
}, {
    id: 12,
    name: "原料小白楼球机",
    cameraName: "原料小白楼球机",
    classifyName: "清洁道路",
    nvrPassword: "hik12345",
    nvrUsername: "admin",
    //ipAddress: "30.100.102.4",
    noReplay: true,
    nvrIp: "172.31.64.3",
    channelId: "12",
    cameraIp: "30.100.102.4",
    password: "hik12345",
    top: 1150,
    left: 330,
    transform: 'rotate(270deg)',
    latitude: 39.49355674,
    longitude: 118.27715780
}, {
    id: 10,
    name: "850炼钢8号门球机",
    cameraName: "850炼钢8号门球机",
    classifyName: "清洁道路",
    nvrPassword: "hik12345",
    nvrUsername: "admin",
    //ipAddress: "30.100.102.6",
    noReplay: true,
    nvrIp: "172.31.64.3",
    channelId: "10",
    cameraIp: "30.100.102.6",
    password: "hik12345",
    top: 1200,
    left: 500,
    transform: 'rotate(270deg)',
    latitude: 39.49860832,
    longitude: 118.27688938
}, {
    id: 9,
    name: "能管中心球机",
    cameraName: "能管中心球机",
    classifyName: "清洁道路",
    nvrPassword: "hik12345",
    nvrUsername: "admin",
    //ipAddress: "30.100.102.11",
    noReplay: true,
    nvrIp: "172.31.64.4",
    channelId: "9",
    cameraIp: "30.100.102.11",
    password: "hik12345",
    top: 1150,
    left: 480,
    transform: 'rotate(270deg)',
    latitude: 39.49869464,
    longitude: 118.27549448
}, {
    id: 7,
    name: "850大道铁路北球机",
    cameraName: "850大道铁路北球机",
    classifyName: "清洁道路",
    nvrPassword: "hik12345",
    nvrUsername: "admin",
    //ipAddress: "30.100.102.5",
    noReplay: true,
    nvrIp: "172.31.64.4",
    channelId: "7",
    cameraIp: "30.100.102.5",
    password: "hik12345",
    top: 1180,
    left: 630,
    transform: 'rotate(270deg)',
    latitude: 39.50093095,
    longitude: 118.27648442
}, {
    id: 4,
    name: "850大道老北环交叉口球机",
    cameraName: "850大道老北环交叉口球机",
    classifyName: "清洁道路",
    nvrPassword: "hik12345",
    nvrUsername: "admin",
    //ipAddress: "30.100.103.2",
    noReplay: true,
    nvrIp: "172.31.64.4",
    channelId: "4",
    cameraIp: "30.100.103.2",
    password: "hik12345",
    top: 1210,
    left: 730,
    transform: 'rotate(270deg)',
    latitude: 39.50363913,
    longitude: 118.27640814
}, {
    id: 3,
    name: "一炉上坡球机",
    cameraName: "一炉上坡球机",
    classifyName: "清洁道路",
    nvrPassword: "hik12345",
    nvrUsername: "admin",
    //ipAddress: "30.100.103.3",
    noReplay: true,
    nvrIp: "172.31.64.4",
    channelId: "3",
    cameraIp: "30.100.103.3",
    password: "hik12345",
    top: 1000,
    left: 800,
    transform: 'rotate(270deg)',
    latitude: 39.50501084,
    longitude: 118.27411368
}, {
    id: 11,
    name: "一炉风机房门口球机",
    cameraName: "一炉风机房门口球机",
    classifyName: "清洁道路",
    nvrPassword: "hik12345",
    nvrUsername: "admin",
    //ipAddress: "30.100.103.4",
    noReplay: true,
    nvrIp: "172.31.64.4",
    channelId: "11",
    cameraIp: "30.100.103.4",
    password: "hik12345",
    top: 1000,
    left: 685,
    transform: 'rotate(270deg)',
    latitude: 39.50272054,
    longitude: 118.27186443
}, {
    id: 6,
    name: "四炉坡道球机",
    cameraName: "四炉坡道球机",
    classifyName: "清洁道路",
    nvrPassword: "hik12345",
    nvrUsername: "admin",
    //ipAddress: "30.100.102.10",
    noReplay: true,
    nvrIp: "172.31.64.4",
    channelId: "6",
    cameraIp: "30.100.102.10",
    password: "hik12345",
    top: 1020,
    left: 590,
    transform: 'rotate(270deg)',
    latitude: 39.50071718,
    longitude: 118.27419017
}, {
    id: 2,
    name: "新北区烧结球机",
    cameraName: "新北区烧结球机",
    classifyName: "清洁道路",
    nvrPassword: "hik12345",
    nvrUsername: "admin",
    //ipAddress: "30.100.103.8",
    noReplay: true,
    nvrIp: "172.31.64.4",
    channelId: "2",
    cameraIp: "30.100.103.8",
    password: "hik12345",
    top: 820,
    left: 900,
    transform: 'rotate(270deg)',
    latitude: 39.50583615,
    longitude: 118.26695642
}, {
    id: 14,
    name: "厂区西北角球机",
    cameraName: "厂区西北角球机",
    classifyName: "清洁道路",
    nvrPassword: "hik12345",
    nvrUsername: "admin",
    //ipAddress: "30.100.103.9",
    noReplay: true,
    nvrIp: "172.31.64.4",
    channelId: "14",
    cameraIp: "30.100.103.9",
    password: "hik12345",
    top: 800,
    left: 900,
    transform: 'rotate(270deg)',
    latitude: 39.50752410,
    longitude: 118.26450198
}, {
    id: 1,
    name: "GL3路口球机",
    cameraName: "GL3路口球机",
    classifyName: "清洁道路",
    nvrPassword: "hik12345",
    nvrUsername: "admin",
    //ipAddress: "30.100.102.8",
    noReplay: true,
    nvrIp: "172.31.64.5",
    channelId: "1",
    cameraIp: "30.100.102.8",
    password: "hik12345",
    top: 780,
    transform: 'rotate(270deg)',
    left: 825,
    latitude: 39.50287248,
    longitude: 118.26473650
}, {
    id: 8,
    name: "原料门口球机",
    cameraName: "原料门口球机",
    classifyName: "清洁道路",
    nvrPassword: "hik12345",
    nvrUsername: "admin",
    //ipAddress: "30.100.102.9",
    noReplay: true,
    nvrIp: "172.31.64.5",
    channelId: "8",
    cameraIp: "30.100.102.9",
    password: "hik12345",
    top: 800,
    left: 540,
    transform: 'rotate(270deg)',
    latitude: 39.49814245,
    longitude: 118.26573881
}, {
    id: 13,
    name: "西门地泵北球机",
    cameraName: "西门地泵北球机",
    classifyName: "清洁道路",
    nvrPassword: "hik12345",
    nvrUsername: "admin",
    //ipAddress: "30.100.102.12",
    noReplay: true,
    nvrIp: "172.31.64.4",
    channelId: "13",
    cameraIp: "30.100.102.12",
    password: "hik12345",
    top: 820,
    left: 250,
    transform: 'rotate(270deg)',
    latitude: 39.49245107,
    longitude: 118.26620638
}]

export default cameraList;